/**
 * Endpoint de tareas pendientes de trazar — backend REAL (everex-traza-back).
 *
 * GET /api/despacho/pendientes?glnId=N → tareas pendientes desde Plataforma
 * ACSIS, filtradas por el `erp_type` configurado del GLN activo. Distintos
 * GLN pueden estar en flujos distintos del ERP (A01, A02, TAE, etc.).
 */

import { GetTareasPendientesResponse, type TareaPendiente } from '@/api/contracts/tareas';
import { apiFetch } from '@/api/http';

export async function getTareasPendientes(glnId: string | number): Promise<TareaPendiente[]> {
  const data = await apiFetch<unknown>(
    `/despacho/pendientes?glnId=${encodeURIComponent(String(glnId))}`,
    { auth: true },
  );
  return GetTareasPendientesResponse.parse(data);
}
